import { Box, Button } from '@fabric-ds/react';
import Illustration from 'resources/Illustration';
import { HeltHjem } from 'types';
import {
    trackMoreAboutFiksFerdig,
    trackShippingAlternatives,
} from 'utils/pulse';

type Props = {
    finnkode: string;
    helthjem: HeltHjem;
};

const Helthjem = (props: Props) => {
    const {
        finnkode,
        helthjem: {
            title,
            text,
            actions: { moreInfo, alternatives },
        },
    } = props;

    const handleFiksFerdigClick = () => {
        trackMoreAboutFiksFerdig(finnkode);
        window.location.href = moreInfo.link;
    };

    const handleAlternativesClick = () => {
        trackShippingAlternatives(finnkode);
        window.location.href = alternatives.link;
    };

    return (
        <Box as="section" info className="grid grid-rows-2 grid-cols-3 m-16">
            <Illustration
                id="man-svg"
                className="justify-self-end md:row-span-3 md:self-center lg:row-span-1"
            />
            <div className="row-start-1 row-end-2 col-span-2">
                <h2 className="h4">{title}</h2>
                <p>{text}</p>
            </div>
            <div
                id="button-container"
                className="flex flex-col md:flex-row lg:flex-col row-span-3 md:row-span-2 lg:row-span-3 col-span-full md:col-span-1 lg:col-span-full gap-16 mt-6 md:text-12 lg:text-16"
            >
                <Button
                    onClick={handleFiksFerdigClick}
                    secondary
                    // Cannot set md:button--small as it is not a tailwind class, so have to set padding and font size self
                    className="min-w-full items-center md:min-w-max lg:min-w-full md:mr-16 md:px-20 md:py-6 lg:py-12"
                >
                    {moreInfo.text}
                </Button>

                <Button
                    onClick={handleAlternativesClick}
                    link
                    className="min-w-full items-center md:min-w-max lg:min-w-full "
                >
                    {alternatives.text}
                </Button>
            </div>
        </Box>
    );
};

export default Helthjem;
